<template>
  <!-- 舆情审核 -->
  <div class="check_situation">
    <div class="accident">
      <div class="tip">舆情级别</div>
      <div class="drop_down" @click="showQuarter">
        <span v-if="!selectQuarter.text">请选择</span>
        <span class="selected" v-if="selectQuarter.text">{{selectQuarter.text}}</span>
        <img src="@/assets/appraise/arrow_right.png" alt />
      </div>
    </div>
    <!-- 单州市 -->
    <!-- <div class="accident">
      <div class="tip">考评扣分</div>
      <div class="score">-{{accidentScore}}</div>
    </div>-->
    <!-- 多州市 -->
    <div class="more_city">
      <div class="tip">考评扣分</div>
      <div class="score">
        <div class="scores">-{{ totalScore }}</div>
        <div v-if="multiAreaData" class="citys">{{multiAreaData}}</div>
      </div>
    </div>
    <div class="btn">
      <van-button @click="submit" type="primary" size="large">提交</van-button>
    </div>
    <confirmDialog
      v-if="showDialog"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirmDialog>
    <commonPicker
      ref="commonPickerQuarter"
      :typeList="newQuarterList"
      :title="title"
      :cols="cols1"
      @getTypeValue="getTypeValue"
    ></commonPicker>
  </div>
</template>

<script>
import confirmDialog from "../components/confirmDialog.vue";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
  components: {
    confirmDialog,
    commonPicker
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: "",
      dialogContent: "请确认该州（市）数据及扣分准确无误",
      cancelBtn: "",
      confirmBtn: "",
      show: false,
      message: "",
      negativeDesc: {},
      selectQuarter: {},
      accidentScore: 0,
      multiAreaData: '',
      totalScore: '',
      newQuarterList: [
        [
          { id: "one", text: "一级负面舆情", count: 10 },
          { id: "two", text: "二级负面舆情", count: 5  },
          { id: "three", text: "三级负面舆情", count: 2  },
          { id: "normal", text: "一般负面舆情", count: 0.33  }
        ]
      ],
      cols1: 1,
      title: "",
      navTextList: []
    };
  },
  created() {
    this.queryDetail();
  },
  methods: {
    showQuarter() {
      // 唤起事故等级选择组件
      this.$refs.commonPickerQuarter.showPicker();
    },
    // 查询详情
    queryDetail() {
      let params = {
        id: this.$route.query.id
      };
      api.getOpinionDetail(params).then(res => {
        if (res.ret === 0) {
          this.negativeDesc = res.data.detailResVOS[0];
          this.selectQuarter = (this.newQuarterList[0].filter(item => {
            return this.negativeDesc.opinionLevel === item.id;
          }))[0],
          this.totalScore = this.newQuarterList[0].filter(item => {
            if (this.negativeDesc.opinionLevel === item.id) {
              return item;
            }
          })[0].count;
          this.navTextList = res.data.detailResVOS.map(item => {
            return {
              areaName: item.areaName,
              deducRate: item.deducRate / 100
            }
          })
          let obj = {};
          if (this.navTextList && this.navTextList.length > 1) {
            this.navTextList.forEach(item => {
              obj[item.areaName] = (-item.deducRate * this.totalScore).toFixed(2);
            })
            console.log(this.navTextList, obj)
            this.multiAreaData = JSON.stringify(obj).replace(/'/g, '').replace(/"/g, '').replace(/{/g, '').replace(/}/g, '').replace(/:/g, '');
          }
          // this.multiAreaData = res.data.multiAreaDataStr;
        }
      });
    },
    // 提交
    submit() {
      (this.dialogTitle = "是否提交审核"),
        (this.cancelBtn = "取消"),
        (this.confirmBtn = "提交"),
        (this.showDialog = true);
    },
    // 弹窗确认回调
    confirm() {
      const { area, year, quarter} = this.$route.query;
      this.showDialog = false;
      let params = {
        id: this.$route.query.id,
        opinionLevel: this.selectQuarter.id
      }
      api.badOpinionAudit(params).then(res => {
        if(res.ret === 0) {
          this.$Toast({
            message: '审核成功',
            icon
          })
          setTimeout(()=>{
            this.$router.back(-1);
          },2000)
        }
      })
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    },
    // 选中舆情级别回调
    getTypeValue(value) {
      this.selectQuarter = value[0];
      let obj = {};
      if(value[0].id === 'one') {
        this.totalScore = 10;
      }else if(value[0].id === 'two') {
        this.totalScore = 5;
      }else if(value[0].id === 'three') {
        this.totalScore = 2;
      }else if(value[0].id === 'normal') {
        this.totalScore = 0.33;
      }
      if (this.navTextList && this.navTextList.length > 1) {
        this.navTextList.forEach(item => {
          obj[item.areaName] = (-item.deducRate * this.totalScore).toFixed(2);
        })
        this.multiAreaData = JSON.stringify(obj).replace(/'/g, '').replace(/"/g, '').replace(/{/g, '').replace(/}/g, '').replace(/:/g, '');
      }
    }
  }
};
</script>

<style scoped lang="less">
.check_situation {
  height: 100%;
  background-color: #fbfbfb;
}
.more_city {
  display: flex;
  justify-content: space-between;
  padding: 16px 12px 16px;
  background-color: #fff;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .scores {
    margin-bottom: 8px;
    color: #666;
    font-size: 14px;
    text-align: right;
  }
  .citys {
    width: 260px;
    font-size: 12px;
    color: #999;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    text-align: right;
  }
}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 12px 16px;
  height: 46px;
  border-bottom: 1px solid #ededed;
  background-color: #fff;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
  }
  .score {
    color: #666;
    font-size: 14px;
  }
}
.btn {
  margin-top: 16px;
  padding: 0 12px;
  ::v-deep .van-button {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
</style>